import React, { useEffect } from "react";
// import Header from "../Header/Header";
import NewHeader from "../NewHeader/NewHeader";
import "./Unsubscribe.css";
import Footer from "../Footer/Footer";
import TopNav from "../TopNav/TopNav";
import { UnsubscribeUser } from "../../Redux/Actions";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";

function Unsubscribe() {
  const params = useParams();
  console.log(params);
  let { id } = params;
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(UnsubscribeUser(id));
  }, [id]);
  return (
    <>
      {/* <TopNav /> */}
      <NewHeader />
      <div className="unsubScribe">
        <h1>
          {" "}
          You have successfully unsubscribed to Redcliffe Labs Newsletter!
        </h1>
      </div>
      <Footer />
    </>
  );
}

export default {
  component: Unsubscribe,
};
